
import Vue, { PropType } from "vue";
import { DialogI } from "@/types/dialog";
import BaseDialog from "@/components/dialog/BaseDialog.vue";
import RepetitionAudioCourses from "@/components/repetitionAudio/RepetitionAudioCourseList.vue";
import { DialogCloseType } from "@/types/dialog";

export default Vue.extend({
  name: "RepetitionAudioSelectCourseDialog",
  components: {
    BaseDialog,
    RepetitionAudioCourses,
  },
  props: {
    dialog: {
      type: Object as PropType<DialogI>,
      required: true,
    },
  },
  methods: {
    close() {
      this.dialog.close({ type: DialogCloseType.CLOSED, payload: {} });
    },
  },
});
